module.exports = __webpack_public_path__ + "static/media/CSS-02.f2be8a4c.svg";